module.exports = __webpack_public_path__ + "static/media/vector.01832d95.svg";